import { createContext, useContext } from 'react';

export const SettingsDisabledContext = createContext<boolean>(false);

export const useSettingsDisabled = () => useContext(SettingsDisabledContext);
